module.exports = __webpack_public_path__ + "img/step4-02.a876fa37.jpg";